import { CCStructureItem } from "../cclib/types/structure";

export const uvaMedAnnualReviewStructure: CCStructureItem[] = [
  {
    type: "grid",
    rows: 4,
    columns: 2,
    sections: [
      {
        name: "Name",
        type: "string",
        child: true,
        readOnly: true,
        key: "faculty_name"
      },
      {
        name: "Rank",
        type: "string",
        readOnly: true,
        child: true,
        key: "faculty_rank"
      },
      {
        name: "Department",
        type: "string",
        child: true,
        readOnly: true,
        key: "faculty_department"
      },
      {
        name: "Division",
        type: "select",
        child: true,
        key: "faculty_division",
        options: [] // Generated at runtime
      },
      {
        name: "Track",
        type: "select",
        child: true,
        yearAgnostic: true,
        key: "faculty_track",
        options: [
          "Academic Investigator",
          "Clinical Educator",
          "Clinical Faculty"
        ]
      },
      {
        name: "Years in Rank",
        type: "string",
        child: true,
        key: "faculty_years_in_rank"
      },
      {
        name: "Years on Track",
        type: "string",
        child: true,
        key: "faculty_years_on_track"
      }
    ]
  },
  {
    type: "header",
    name: "TIME ALLOCATION"
  },
  {
    type: "header",
    name: "On average during the past year, how was your time divided among the following activities (total should be 100%):"
  },
  {
    type: "grid",
    rows: 3,
    columns: 2,
    sections: [
      {
        name: "% Research",
        type: "string",
        child: true,
        key: "percent_research"
      },
      {
        name: "% Patient Care",
        type: "string",
        child: true,
        key: "percent_care"
      },
      {
        name: "% Teaching",
        type: "string",
        child: true,
        key: "percent_teaching"
      },
      {
        name: "% Administrative",
        type: "string",
        child: true,
        key: "percent_admin"
      },
      {
        name: "% Other",
        type: "string",
        child: true,
        key: "percent_other"
      }
    ]
  },
  {
    text: "Please specify other:",
    type: "paragraph",
    richText: true,
    key: "percent_other_specify"
  },
  {
    name: "Do you expect this allocation of effort to change significantly (greater than 10%) next year?",
    type: "select",
    key: "percent_expect_change",
    options: ["Yes", "No"]
  },
  {
    text: "If yes, please explain:",
    type: "paragraph",
    richText: true,
    key: "percent_yes_explain"
  },
  {
    type: "header",
    name: "ACADEMIC AND RESEARCH PRODUCTIVITY"
  },
  {
    type: "custom",
    key: "custom-papers-summary"
  },
  {
    type: "custom",
    key: "custom-lectures-summary"
  },
  {
    type: "custom",
    key: "custom-papers-detail"
  },
  {
    type: "custom",
    key: "custom-lectures-detail"
  },
  {
    type: "paragraph",
    key: "research_activities_areas",
    richText: true,
    text: "Research Activities - Areas of Research Interest:"
  },
  {
    type: "paragraph",
    key: "research_activities_current",
    richText: true,
    text: "Research Activities - Current Projects:"
  },
  {
    type: "paragraph",
    key: "research_activities_collab",
    richText: true,
    text: "Research Activities - Research Collaborations / Team Science:"
  },
  {
    type: "custom",
    key: "custom-funded"
  },
  {
    type: "custom",
    key: "custom-unfunded"
  },
  {
    type: "header",
    name: "PATIENT CARE AND CLINICAL PRODUCTIVITY"
  },
  {
    type: "grid",
    rows: 5,
    columns: 2,
    sections: [
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_gross_rev",
        name: "Gross Revenue billed as of 5/31"
      },
      {
        type: "string",
        optional: true,
        child: true,
        readOnly: true,
        key: "care_gross_rev_prior",
        name: "Prior Year"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_visits",
        name: "# of Clinic Visits"
      },
      {
        type: "string",
        optional: true,
        child: true,
        readOnly: true,
        key: "care_visits_prior",
        name: "Prior Year"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_work_rvus",
        name: "# of Work RVUs billed"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_work_rvus_prior",
        readOnly: true,
        name: "Prior Year"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_operations",
        name: "# of Operations Performed"
      },
      {
        type: "string",
        optional: true,
        child: true,
        readOnly: true,
        key: "care_operations_prior",
        name: "Prior Year"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_inpatient_score",
        name: "Inpatient Patient Satisfaction Score"
      },
      {
        type: "string",
        optional: true,
        child: true,
        key: "care_outpatient_score",
        name: "Outpatient Patient Satisfaction Score"
      }
    ]
  },
  {
    type: "paragraph",
    key: "clinical_productivity_context",
    richText: true,
    optional: true,
    text: "Provide context on clinical productivity as appropriate"
  },
  {
    type: "header",
    name: "TEACHING AND EDUCATIONAL ACTIVITIES"
  },
  {
    type: "custom",
    key: "custom-teaching-classroom"
  },
  {
    type: "custom",
    key: "custom-teaching-clinical"
  },
  {
    type: "custom",
    key: "custom-teaching-conferences"
  },
  {
    type: "custom",
    key: "custom-teaching-committees"
  },
  {
    type: "custom",
    key: "custom-teaching-counseling"
  },
  {
    type: "custom",
    key: "custom-teaching-study"
  },
  {
    type: "custom",
    key: "custom-teaching-research"
  },
  {
    type: "custom",
    key: "custom-teaching-bibliography"
  },
  {
    type: "custom",
    key: "custom-teaching-other"
  },
  {
    type: "custom",
    key: "custom-other-contribution"
  },
  {
    type: "header",
    name: "ADMINISTRATIVE AND DEVELOPMENT CONTRIBUTIONS"
  },
  {
    type: "header",
    name: "Committees & Councils"
  },
  {
    type: "custom",
    key: "custom-admin-som"
  },
  {
    type: "custom",
    key: "custom-admin-university"
  },
  {
    type: "custom",
    key: "custom-admin-uva"
  },
  {
    type: "custom",
    key: "custom-admin-department"
  },
  {
    type: "custom",
    key: "custom-admin-national"
  },
  {
    type: "custom",
    key: "custom-admin-state"
  },
  {
    type: "header",
    name: "RECOGNITION, HONORS, AND AWARDS"
  },
  {
    type: "custom",
    key: "custom-recognition"
  },
  {
    type: "header",
    name: "DEMONSTRATION OF ASPIRE VALUES",
    text: "Include a brief self-evaluation in your annual review regarding adherence to the UVAHealth ASPIRE values by describing at least one example of activities that demonstrate an ASPIRE value. For details see SOM Code of Conduct from the link on this page: <a href='https://med.virginia.edu/policies/university-of-virginia-school-of-medicine-code-of-conduct/' target='_blank'>https://med.virginia.edu/policies/university-of-virginia-school-of-medicine-code-of-conduct/</a>"
  },
  {
    type: "paragraph",
    richText: true,
    optional: true,
    key: "aspire_values"
  },
  {
    type: "header",
    name: "ACHIEVEMENTS AND GOALS",
    text: "Achievements: List what you consider your major achievements for this year:"
  },
  {
    type: "paragraph",
    richText: true,
    key: "achievements"
  },
  {
    type: "grid",
    text: "Progress towards prior year goals: List prior year goals (academic/professional) and progress towards completion:",
    rows: 1,
    columns: 2,
    sections: [
      {
        type: "paragraph",
        readOnly: true,
        child: true,
        orientation: "vertical",
        key: "goals_prior",
        text: "Prior Year Goals:"
      },
      {
        type: "paragraph",
        richText: true,
        child: true,
        orientation: "vertical",
        key: "goals_progress",
        text: "Progress to Completion:"
      }
    ]
  },
  {
    type: "paragraph",
    richText: true,
    key: "goals_coming",
    text: "Goals:  List at least three academic/professional goals for the coming year:"
  },
  {
    type: "paragraph",
    richText: true,
    key: "goals_steps",
    text: "Describe your 3 to 5 year goals and steps you will take this year to achieve those goals:"
  },
  {
    type: "paragraph",
    richText: true,
    key: "goals_help",
    text: "How can the department help you succeed in achieving these goals?"
  },
  {
    type: "header",
    name: "ITEMS FOR DISCUSSION"
  },
  {
    type: "paragraph",
    richText: true,
    text: "What other topics would you like to discuss during the evaluation meeting?",
    key: "discussion_items",
    optional: true
  },
  {
    type: "header",
    name: "COMMENTS FROM THE SUPERVISOR",
    isMentorField: true
  },
  {
    isMentorField: true,
    richText: true,
    type: "paragraph",
    key: "supervisor_comments",
    text: `<ul><li>Include comments regarding discussion of academic advancement for all assistant/associate professors.</li><li>Include comments on reported effort vs. funding support.</li><li>Please indicate if the faculty member “meets expectations”, “exceeds expectations”, or “does not meet expectations” and include comments on performance relative to expectations.</li><li>Where performance does not meet expectations, outline performance improvement plan and plans for quarterly follow-up on progress.</li></ul>`
  }
];

const adminTableColumns = [
  { display: "Date", db: "date" },
  { display: "Name of Committee", db: "name" },
  { display: "Organization", db: "organization" }
];
export const adminCustomTableSections = {
  som: {
    text: "School of Medicine",
    dbtype: "school",
    columns: adminTableColumns
  },
  university: {
    text: "University",
    dbtype: "institutional",
    columns: adminTableColumns
  },
  uva: {
    text: "UVA Hospitals",
    dbtype: "local",
    columns: adminTableColumns
  },
  department: {
    text: "Department",
    dbtype: "dept",
    columns: adminTableColumns
  },
  national: {
    text: "National",
    dbtype: "national",
    columns: adminTableColumns
  },
  state: {
    text: "State",
    dbtype: "regional",
    columns: adminTableColumns
  }
};
export const teachingCustomTableSections = {
  classroom: {
    text: "Classroom, Seminar, or Teaching Laboratory",
    dbtype: "Teaching of Students in Courses",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "% Responsibility", db: "location" }
    ]
  },
  clinical: {
    text: "Clinical Teaching (in ward, clinic, OR)",
    dbtype: "Clinical Supervisory and Training Responsibilities",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  conferences: {
    text: "Conferences, Grand Rounds, Journal Clubs, etc",
    dbtype:
      "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)",
    columns: [
      { display: "Date", db: "date" },
      { display: "Type of Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  committees: {
    text: "Teaching Committees",
    dbtype: "educationalLeadership",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  counseling: {
    text: "Student Counseling",
    dbtype: "counseling",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  study: {
    text: "Formal Study to Improve Teaching Abilities",
    dbtype: "study",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  research: {
    text: "Current Research Concerning Teaching",
    dbtype: "research",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  bibliography: {
    text: "Bibliography Concerning Teaching",
    dbtype: "external",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  },
  other: {
    text: "Other, including development of curriculum or new teaching materials, methods of evaluation, program supervision, etc",
    dbtype: "educationalDev",
    columns: [
      { display: "Date", db: "date" },
      { display: "Activity", db: "activity" },
      { display: "Location", db: "location" }
    ]
  }
};
